export const DETAILS_GROUP_DRAWER_TEST_ID = "details-group-drawer";
